// userCache.js — résout et CACHE les profils (pseudo + avatar) par user_id, avec batch. Les messages de
// chat ne portent que le username brut (souvent un id aléatoire type « tuRkjHSyXY ») → on affiche à la
// place le display_name + l'avatar réels. Cache mémoire + abonnés pour re-render à la résolution.
import { nakamaAuth } from './nakamaAuth';

const cache = {};              // id -> { name, avatar }
const pending = new Set();
const subs = new Set();
let queue = new Set();
let timer = null;

function emit() { subs.forEach((cb) => { try { cb(); } catch { /* */ } }); }
const isHexId = (s) => /^[0-9a-f-]{6,}$/i.test(s || '');

// Nom lisible : display_name si présent (et pas un id), sinon username lisible, sinon « joueur_xxxxxx ».
function friendlyName(u) {
  if (u.display_name && !isHexId(u.display_name)) return u.display_name;
  if (u.username && !isHexId(u.username)) return u.username;
  return 'joueur_' + String(u.id || '').replace(/-/g, '').slice(0, 6);
}

export function cachedUser(id) { return cache[id]; }
export function onUserCache(cb) { subs.add(cb); return () => subs.delete(cb); }

// Demande la résolution d'un id (déclenche un batch groupé après un court délai).
export function resolveUser(id) {
  if (!id || cache[id] || pending.has(id)) return;
  queue.add(id); pending.add(id);
  clearTimeout(timer);
  timer = setTimeout(flush, 120);
}

async function flush() {
  const ids = [...queue]; queue = new Set();
  if (!ids.length) return;
  const users = await nakamaAuth.getUsers(ids);
  users.forEach((u) => { cache[u.id] = { name: friendlyName(u), avatar: u.avatar_url || '' }; });
  ids.forEach((id) => pending.delete(id));   // même sans réponse, on ne re-boucle pas indéfiniment
  emit();
}
